// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__wZiCP","colCheckbox":"styles_colCheckbox__CF-fi"};